import React, { useState } from "react";
import { useSelector } from "react-redux";
import TinyMCEEditor from "../TinyMCEEditor";
import classes from './Question.module.css';
import QuestionOptions from "./QuestionOptions/QuestionOptions";
import QuestionSettings from "./QuestionSettings/QuestionSettings";
import QuestionText from "./QuestionText/QuestionText";
import settingsIcon from '../../assests/settings.svg';
import sideArrow from '../../assests/arrow-side.svg';
import downArrow from '../../assests/arrow-down.svg';

const quetionsComponentEnum = {
    'options': QuestionOptions,
    'text': QuestionText
}

const Question = ({ id, index, name, data, type, points, config, setQuestionFirstLevelFields, onDelete, onDuplicate, onOrderDown, onOrderUp }) => {
    const Component = quetionsComponentEnum[type];
    const { texts } = useSelector(state => state.translate);
    const [settings, setSettings] = useState(false)

    const setQuestionInnerData = (newData) => {
        setQuestionFirstLevelFields({ data: { ...data, ...newData } })
    }
    return <div className={classes.Question}>
        <div className={classes.Actions}>
            <div className={`${classes.Action} ${classes.ActionDown}`} onClick={onOrderDown} ></div>
            <div className={`${classes.Action} ${classes.ActionUP}`} onClick={onOrderUp}></div>
            <div className={`${classes.Action} ${classes.ActionDuplicate}`} onClick={onDuplicate}></div>
            <div className={`${classes.Action} ${classes.ActionDelete}`} onClick={onDelete}></div>
        </div>
        <div className={classes.Name}>
            <div className={classes.Index}>{index}.</div>
            <div className={classes.NameInput}><TinyMCEEditor id={id} data={name} inline={true} setContentData={(content) => setQuestionFirstLevelFields({ name: content })}></TinyMCEEditor></div>
        </div>
        <Component id={id} {...data} index={index} onDataChange={setQuestionInnerData}></Component>
        <div className={classes.Settings} onClick={() => setSettings(!settings)}>
            <img src={settings ? downArrow : sideArrow} />
            <img src={settingsIcon} />
            <p className={classes.SettingsText}>{texts.settings}</p>
        </div>
        {settings && <QuestionSettings
            id={id}
            config={config}
            data={data}
            points={points}
            setQuestionFirstLevelFields={setQuestionFirstLevelFields}
            setQuestionInnerData={setQuestionInnerData} />}
    </div>
}
export default Question;